export const ArrowIcon = () => (
  <svg
    className="svg"
    width="10"
    height="5"
    viewBox="0 0 10 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.67267 4.71653C4.86056 4.87924 5.13944 4.87924 5.32733 4.71653L9.18236 1.37797C9.53232 1.0749 9.31798 0.5 8.85504 0.5H1.14496C0.682019 0.5 0.467682 1.0749 0.817634 1.37796L4.67267 4.71653Z"
      fill="currentColor"
    />
  </svg>
);
